<div
  class="search container p-0"
  [class.active]="searchBarHasFocus"
  tabindex="0"
  (click)="enterSearch()"
  (keyup.enter)="enterSearch()"
>
  <form class="search-form" [formGroup]="searchForm" (ngSubmit)="handleSearch()">
    <div class="form-input-control">
      <div class="leave-search">
        <nmfta-icon
          name="chevron_left"
          color="accent"
          (click)="leaveSearch()"
        ></nmfta-icon>
      </div>

      <nmfta-input-wrapper [showClearButton]="true">
        <input
          #input
          matInput
          type="text"
          autocomplete="off"
          aria-label="search"
          [placeholder]="'SEARCH.SEARCH_PLACEHOLDER' | translate | titlecase"
          formControlName="search"
        />
      </nmfta-input-wrapper>

      @if (searchBarHasFocus) {
        <!-- Tablet & Mobile only -->
        <div class="info-docket-selection">
          <nmfta-icon
            color="info"
            name="help_outline"
            (click)="handleOpenInstructions()"
          >
          </nmfta-icon>
          @if (!displayingFilters) {
            <nmfta-icon
              color="accent"
              name="tune"
              (click)="toggleFilters()"
            >
            </nmfta-icon>
          }
        </div>
      }
    </div>

    @if (searchBarHasFocus) {
      <!-- desktop -->
      <div class="search-actions-lg">
        <ng-container *ngTemplateOutlet="actionsLG"></ng-container>
      </div>

      <!-- mobile -->
      <div class="search-actions-md">
        <div class="search-buttons">
          <ng-container *ngTemplateOutlet="searchButtons"></ng-container>
        </div>
      </div>

      <!--  Display filters only when the user clicks on the filters CTA  -->
      @if (displayingFilters) {
        <ng-container *ngTemplateOutlet="filters"></ng-container>
      }

      <!-- Display suggestions only when no filters are being applied -->
      @if (!displayingFilters) {
        <ng-container *ngTemplateOutlet="suggestions"></ng-container>
      }
    }
  </form>
</div>

<ng-template #actionsLG>
  <div class="search-buttons">
    <div class="left-side">
      <nmfta-button
        [leftIcon]="displayingFilters ? 'close' : 'tune'"
        [styleType]="'text'"
        [color]="displayingFilters ? 'error' : 'accent'"
        (buttonClick)="toggleFilters()"
      >
        <span>{{ displayingFilters ? ("SEARCH.CANCEL_FILTERING" | translate) : ("SEARCH.CURRENT_NMFC_CONTENT" | translate) }}</span>
      </nmfta-button>
    </div>
    <div class="right-side">
      <nmfta-button color="info" styleType="text" rightIcon="help_outline" (buttonClick)="handleOpenInstructions()">
        <span class="search-introductions-text">{{ "SEARCH.INSTRUCTIONS_TITLE" | translate }}</span>
      </nmfta-button>
      <ng-container *ngTemplateOutlet="searchButtons"></ng-container>
    </div>
  </div>

</ng-template>

<ng-template #searchButtons>
  @if (!displayCompactMode && !displayingFilters) {
    <nmfta-button
      class="search-detailed"
      styleType="outlined"
      [disabled]="!validForm()"
      (buttonClick)="handleDetailedSearch(input.value, $event)">
      {{ "SEARCH.DETAILED_SEARCH" | translate }}
    </nmfta-button>
  } @else if (displayingFilters) {
    <div class="d-md-none">
      <nmfta-button
        class="toggle-filters"
        [leftIcon]="displayingFilters ? 'close' : 'tune'"
        [styleType]="'text'"
        [color]="displayingFilters ? 'error' : 'accent'"
        (buttonClick)="toggleFilters()"
      >
        <span>{{ displayingFilters ? ("SEARCH.CANCEL_FILTERING" | translate) : ("SEARCH.CURRENT_NMFC_CONTENT" | translate) }}</span>
      </nmfta-button>
    </div>
  }
  <nmfta-button
    class="search-submit"
    [class.with-detail]="!displayCompactMode && !displayingFilters"
    styleType="contained"
    rightIcon="search"
    [type]="'submit'"
    [disabled]="!validForm()"
  >
    <span>{{ displayingFilters ? ("SEARCH.APPLY_AND_SEARCH" | translate) : ("SHARED.SEARCH" | translate) }}</span>
  </nmfta-button>
</ng-template>

<ng-template #filters>
  <div class="filter-panel-content" [formGroup]="searchForm">
    <div class="filters-instructions">{{ "SEARCH.FILTER_INSTRUCTIONS" | translate }}</div>
    <div class="row">

      <!-- NMFC Content As Of Date -->
      <div class="filter-container col"
           tabindex="-1"
           (click)="setActiveInput('contentDate')"
           (keyup.enter)="setActiveInput('contentDate')">
        <nmfta-input-wrapper [label]="'SEARCH.NMFC_CONTENT_INPUT' | translate">
          <input matInput
                 nmftaDateMask
                 [min]="minDate"
                 [max]="maxDate"
                 [matDatepicker]="contentDatePicker"
                 placeholder="{{'SEARCH.SELECT_DATE' | translate}}"
                 formControlName="contentDate"
          />
          <mat-datepicker-toggle matSuffix
                                 [for]="contentDatePicker"
                                 (click)="setActiveInput('contentDate')"
          />
          <mat-datepicker #contentDatePicker/>
        </nmfta-input-wrapper>
      </div>

      <!-- NMFC Supplements Date Range -->
      <div class="filter-container col"
           tabindex="-1"
           (click)="setActiveInput('supplementDateRange')"
           (keyup.enter)="setActiveInput('supplementDateRange')">
        <nmfta-input-wrapper [label]="'SEARCH.NMFC_SUPPLEMENT_DATE_RANGE' | translate">
          <mat-date-range-input [rangePicker]="rangeDatePicker"
                                [min]="minDate"
                                [max]="maxDate">
            <input matStartDate
                   nmftaDateMask
                   formControlName="supplementDateFrom"
                   [placeholder]="'SHARED.FROM' | translate"
            />
            <input matEndDate
                   nmftaDateMask
                   formControlName="supplementDateTo"
                   [placeholder]="'SHARED.TO' | translate"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix
                                 [for]="rangeDatePicker"
                                 (click)="setActiveInput('supplementDateRange')"
          />
          <mat-date-range-picker #rangeDatePicker/>
        </nmfta-input-wrapper>
      </div>

      <!-- NMFC Supplement -->
      <div class="filter-container col"
           tabindex="-1"
           (click)="setActiveInput('supplement')"
           (keyup.enter)="setActiveInput('supplement')"
      >
        <nmfta-input-wrapper [label]="'SEARCH.NMFC_SUPPLEMENT' | translate">
          <mat-select formControlName="supplement" [placeholder]="'Generic_SelectOption' | translate" >
            @for (supplement of supplementFilterOptions$(); track supplement.id) {
              <mat-option [value]="supplement.id">
                {{ supplement.text }}
              </mat-option>
            }
          </mat-select>
        </nmfta-input-wrapper>
      </div>

      <!-- Public Docket Files -->
      <div class="filter-container col"
           tabindex="-1"
           (click)="setActiveInput('publicDocket')"
           (keyup.enter)="setActiveInput('publicDocket')"
      >
        <nmfta-input-wrapper [label]="'SEARCH.NMFC_PUBLIC_DOCKET' | translate">
          <mat-select formControlName="publicDocket" [placeholder]="'Generic_SelectOption' | translate">
            @for(publicDocket of docketFilterOptions$(); track publicDocket.id) {
              <mat-option [value]="publicDocket.id">
                {{ publicDocket.text }}
              </mat-option>
            }
          </mat-select>
        </nmfta-input-wrapper>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #suggestions>
  @if (suggestions$().suggestion.length > 0) {
    <div class="d-flex justify-content-between align-items-center px-4 pb-1">
      <h4 class="m-0">{{ "SEARCH.SUGGESTIONS" | translate }}</h4>
      <h4 class="m-0 pe-5">{{ "SEARCH.SUGGESTION_MATCH" | translate }}</h4>
    </div>
    <div class="suggestions">
      <mat-nav-list>
        @for (suggestion of suggestions$().suggestion; track suggestion.itemNumber) {
          <mat-list-item class="suggestion" (click)="handleSuggestionClick(suggestion, $event)">
            <div class="suggestion-row">
              <span class="suggestion-id w-auto d-flex h-100 align-items-center">{{ suggestion.itemNumber }}</span>
              <span class="suggestion-description col">{{ suggestion.description }}</span>
              <span class="suggestion-description">{{ getSuggestionTypeText(suggestion.resultType) }}</span>
              <span class="suggestion-chevron w-auto d-flex h-100 align-items-center"><nmfta-icon name="chevron_right"></nmfta-icon></span>
            </div>
          </mat-list-item>
        }
      </mat-nav-list>
      @if(suggestions$().hasMore){
        <div class="w-100 d-flex justify-content-center mb-4">
          <nmfta-button (buttonClick)="handleDetailedSearch(input.value, $event)">
            See all results
          </nmfta-button>
        </div>
      }
    </div>
  } @else if (searchInProgress) {
    <div class="d-flex flex-column gap-2 px-4 pb-4 suggestions-loading">
      <ngx-skeleton-loader
        [theme]="{
          height: '20px',
          width: '100px',
          'border-radius': '0.5rem',
        }" />
      <ngx-skeleton-loader
        [theme]="{
          height: '42px',
          width: '100%',
          'max-width': '100%',
          'border-radius': '0.5rem',
        }" />
      <ngx-skeleton-loader
        [theme]="{
          height: '42px',
          width: '100%',
          'max-width': '60%',
          'border-radius': '0.5rem',
        }" />
      <ngx-skeleton-loader
        [theme]="{
          height: '42px',
          width: '100%',
          'max-width': '80%',
          'border-radius': '0.5rem',
        }" />
    </div>
  }
</ng-template>

<ng-template #searchInstructions>
  <div class="search-instructions" [innerHTML]="'SEARCH.INSTRUCTIONS_BODY' | translate "></div>
</ng-template>

@if (searchBarHasFocus) {
  <div
    role="link"
    tabindex="-1"
    class="backdrop"
    (click)="leaveSearch()"
    (keyup.enter)="leaveSearch()"
  ></div>
}
